let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bzdof")).then(() => parcelRequire('b5kse'));